export const MAX_QUOTES_TO_SHOW_AT_START = 3;
